import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/auth";

/* Legacy Firebase configuration 
const firebaseConfig = {
   apiKey: 'AIzaSyB3G2YWHXwaeK9bQHg0bBs3SDgPD32L2AA',
  authDomain: 'milenial-273722.firebaseapp.com',
  databaseURL: 'https://milenial-273722.firebaseio.com',
  projectId: 'milenial-273722',
  storageBucket: 'milenial-273722.appspot.com',
  messagingSenderId: '415129036295',
  appId: '1:415129036295:web:77e21eb21aa478f4eaaca2',
}
*/

const firebaseConfig = {
  apiKey: "AIzaSyB8zFLbshbnnvkrNpwz8uj8EqMXNxeelUI",
  authDomain: "pintaredu-fbffd.firebaseapp.com",
  databaseURL: "https://pintaredu-fbffd.firebaseio.com",
  projectId: "pintaredu-fbffd",
  storageBucket: "pintaredu-fbffd.firebasestorage.app",
  messagingSenderId: "645098493309",
  appId: "1:645098493309:web:ae758761efa7abb8b96814",
  measurementId: "G-N25RNP43F4",
  vapidKey:
    "BJmy_VMGzlosB8xvdePUveD_4rt8Zccom6kLLVZkbpaB40BkUJGkssLZEovuEsaUBJ8RzXWjspshE4M2JTZm95Y",
};

firebase.initializeApp(firebaseConfig);

export const firebaseApp = firebase;

export const messaging = firebase.messaging.isSupported()
  ? firebase.messaging()
  : null;

export const getToken = async () => {
  return messaging
    .getToken({
      vapidKey:
        // Legacy VAPID key
        // 'BEdqfyzHeciHWMnFJ53etX83-bWZGSyC-clAn-3-1Jo70jDoSM6JXtCIBh6oVsM79Zgyc52GtXe-A7Eg8_vTFDE',

        // VAPID key for Web Push Protocol, you can get it from firebase console
        firebaseConfig.vapidKey,
    })
    .then((currentToken) => {
      if (currentToken) {
        console.info("current token for client: ", currentToken);
        return currentToken;
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        console.info(
          "No registration token available. Request permission to generate one.",
        );
        return null;
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      console.error("An error occurred while retrieving token. ", err);
      return null;
      // catch error while creating client token
    });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });

export const loginWithGoogle = async () => {
  try {
    const provider = new firebase.auth.GoogleAuthProvider();
    const result = await firebase.auth().signInWithPopup(provider);
    return result;
  } catch (error) {
    console.error("Error logging in with Google:", error);
    throw error;
  }
};
